/**
 * 管理后台：指挥密码 / 数据库结构导出
 */
import { useState } from 'react';
import { message } from '../utils/antdMessage';

export default function useAdminSecurity({ apiRequest }) {
  const [commandPwd, setCommandPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [pwdMsg, setPwdMsg] = useState('');
  const [showCommandPwd, setShowCommandPwd] = useState(false);
  const [dbSchema, setDbSchema] = useState(null);
  const [schemaLoading, setSchemaLoading] = useState(false);
  const [schemaError, setSchemaError] = useState('');

  const fetchPwd = async () => {
    const data = await apiRequest('/api/admin/command-password');
    if (data.success) {
      setCommandPwd(data.configured ? '********' : '');
    }
  };
  const handleSavePwd = async () => {
    if (!newPwd || String(newPwd).trim().length < 4) {
      return setPwdMsg('请输入至少 4 位新密码');
    }
    setPwdMsg('');
    const data = await apiRequest('/api/admin/settings/update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: 'command_password', value: String(newPwd).trim() })
    });
    if (data.success) {
      setPwdMsg('保存成功（已加密存储，无法回显明文）');
      setCommandPwd('********');
      setNewPwd('');
    } else {
      setPwdMsg(data.error || '保存失败');
    }
  };

  // ========== 数据库结构导出API ==========
  const fetchDbSchema = async () => {
    setSchemaLoading(true);
    setSchemaError('');
    try {
      const data = await apiRequest('/api/admin/export-schema');
      if (data.success) {
        setDbSchema(data.data);
        // 保存到本地文件
        const blob = new Blob([JSON.stringify(data.data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `zhxt_database_schema_${new Date().toISOString().split('T')[0]}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        setSchemaError(data.error || '导出失败');
      }
    } catch (e) {
      setSchemaError('网络错误');
    } finally {
      setSchemaLoading(false);
    }
  };


  return {
    commandPwd, newPwd, setNewPwd, pwdMsg, showCommandPwd, setShowCommandPwd, fetchPwd, handleSavePwd,
    dbSchema, schemaLoading, schemaError, fetchDbSchema
  };
}
